import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-multi-carousel";
import { SiStagetimer } from "react-icons/si";
import DarkArrow from "../../assets/images/dark-arrow.png";
import MidArrow from "../../assets/images/mid-arrow.png";
import SecondMidArrow from "../../assets/images/second-mid-arrow.png";
import ThirdMidArrow from "../../assets/images/third-mid-arrow.png";
import FourthMidArrow from "../../assets/images/fourth-mid-arrow.png";
import LastArrow from "../../assets/images/last-arrow.png";
import FirstLineImg from "../../assets/images/first-time-line-img.webp";
import SecondLineImg from "../../assets/images/second-time-line-img.webp";
import ThirdLineImg from "../../assets/images/third-time-line-img.webp";
import FourthLineImg from "../../assets/images/fourth-time-line-img.webp";
import FifthLineImg from "../../assets/images/fifth-time-line-img.webp";
import SixthLineImg from "../../assets/images/sixth-time-line-img.webp";
import SeventhLineImg from "../../assets/images/seventh-time-line-img.webp";
import EightLineImg from "../../assets/images/eight-time-line-img.webp";
import SecondEightLineImg from "../../assets/images/second-eight-time-line-img.webp";
import NineLineImg from "../../assets/images/nine-time-line-img.webp";
import TenLineImg from "../../assets/images/ten-time-line-img.webp";
import ElevenLineImg from "../../assets/images/eleven-time-line-img.webp";
import TwelveLineImg from "../../assets/images/twelve-time-line-img.webp";
import ThirTeenLineImg from "../../assets/images/thirteen-time-line-img.webp";
import FourthTeenLineImg from "../../assets/images/fourthteen-time-line-img.webp";
import FifthTeenLineImg from "../../assets/images/fifthteen-time-line-img.webp";
import SixTeenLineImg from "../../assets/images/sixteen-time-line-img.webp";
import SevenTeenLineImg from "../../assets/images/seventeen-time-line-img.webp";
import EighTeenLineImg from "../../assets/images/eighteen-time-line-img.webp";
import "./TimeLine.css";

export default function TimeLine(props) {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: 1200, min: 576 },
      items: 3,
      slidesToSlide: 3,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const midColor = "#0e5527";
  const secondMidColor = "#2C6A37";
  const thirdMidColor = "#397C42";
  const lastColor = "#479A52";

  return (
    <Container className="time-line-section">
      <Row>
        <Col className="time-line-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <SiStagetimer
              style={{ color: props.iconColor }}
              className="time-line-first-icon"
            />
            MAIS DE 100 ANOS DE HISTÓRIA
          </h2>
        </Col>
      </Row>
      <Carousel
        showDots={true}
        responsive={responsive}
        transitionDuration={300}
        swipeable={true}
        draggable={true}
        containerClass="time-line-carousel-container"
        partialVisible={false}
      >
        <div className="time-line-card-start">
          <h3
            className="first-card-title"
            style={{ color: props.iconColor, fontSize: props.subTitleSize }}
          >
            1ª Geração
          </h3>
          <img
            src={DarkArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <p
            className="first-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            Carlos Krause <br />e<br /> Adolfina Krause
          </p>
        </div>
        <div className="time-line-card-mid">
          <img
            src={FirstLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={DarkArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: props.iconColor, fontSize: props.subTitleSize }}>
            1922
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Ano de fundação da Funerária Krause</b>
            <br />
            Como uma pequena fabriqueta de móveis que as famílias procuravam
            para fabricar o caixão.
          </p>
        </div>
        <div className="time-line-card-end">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>A empresa passa a se chamar Viúva Adolfina Krause</b>
            <br />
            Com o falecimento do Sr. Carlos Krause, Adolfina assume o negócio
            com as filhas Fredalina Sparrenberguer e Frieda Schunk.
          </p>
          <h3 style={{ color: props.iconColor, fontSize: props.subTitleSize }}>
            1934
          </h3>
          <img
            src={DarkArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={SecondLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-start">
          <h3
            className="second-card-title"
            style={{ color: midColor, fontSize: props.subTitleSize }}
          >
            2ª Geração
          </h3>
          <img
            src={MidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <p
            className="first-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            Fredalina Sparrenberguer <br />e<br />
            Antônio Angelo Franceschetti
          </p>
        </div>
        <div className="time-line-card-end">
          <img
            src={ThirdLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={MidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: midColor, fontSize: props.subTitleSize }}>
            1950
          </h3>
          <p
            className="mid-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Mudanças de administração</b>
            <br /> Antônio Franceschetti, casado com Fredalina Sparrenberguer, e
            seu primo Alberto Vanzela, casado com a Frieda Schunk, assumem a
            empresa. No mesmo ano, Antônio Franceschetti se retira da sociedade,
            ficando o negócio sob a administração do Alberto Vanzela.
          </p>
        </div>
        <div className="time-line-card-mid">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Retorno de Antônio Franceschetti.</b>
            <br /> Após dificuldades nos negócios, Antônio Franceschetti retorna
            à empresa a convite de Adolfina Krause, com exigência de que Alberto
            Vanzela se retirasse do negócio.
          </p>
          <h3 style={{ color: midColor, fontSize: props.subTitleSize }}>
            1961
          </h3>
          <img
            src={MidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={FourthLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-end">
          <img
            src={MidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: midColor, fontSize: props.subTitleSize }}>
            1967
          </h3>
          <p
            className="third-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Entrada de Alberto Franceschetti</b>
            <br /> Antônio Franceschetti contrata seu filho, Alberto. Nessa
            época, a empresa era chamada Frieda Schunk & Cia Ltda.
          </p>
        </div>
        <div className="time-line-card-start">
          <h3
            className="second-card-title"
            style={{ color: secondMidColor, fontSize: props.subTitleSize }}
          >
            3ª Geração
          </h3>
          <img
            src={SecondMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <p
            className="first-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            Sr. Alberto Franceschetti <br />e<br />
            Sra. Elisabeth Franceschetti
          </p>
        </div>
        <div className="time-line-card-mid">
          <img
            src={FifthLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={SecondMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: secondMidColor, fontSize: props.subTitleSize }}>
            1981
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Mudanças de nome para FUNERÁRIA KRAUSE LTDA.</b>
            <br />
            Alberto Franceschetti assume a empresa e muda a razão social para o
            nome pelo qual é conhecida até hoje.
          </p>
        </div>
        <div className="time-line-card-end">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Mudança de endereço.</b>
            <br /> A Funerária Krause se muda a Av. Maurício Cardoso,
            consolidando-se ainda mais e tornando-se uma marca reconhecida.
          </p>
          <h3 style={{ color: secondMidColor, fontSize: props.subTitleSize }}>
            1986
          </h3>
          <img
            src={SecondMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={SixthLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-start">
          <h3
            className="second-card-title"
            style={{ color: thirdMidColor, fontSize: props.subTitleSize }}
          >
            4ª Geração
          </h3>
          <img
            src={ThirdMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <p
            className="first-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            Gilberto Franceschetti <br />e<br />
            Cristiano Franceschetti
          </p>
        </div>
        <div className="time-line-card-mid">
          <img
            src={SeventhLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            1998
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Entrada de Gilberto e Cristiano</b>
            <br /> Filhos de Alberto e Elisabeth Franceschetti, passam a atuar
            mais fortemente na empresa. Eles laçam o PAK - Plano Assistencial
            Krause.
          </p>
        </div>
        <div className="time-line-card-end">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Inauguração das capelas mortuárias</b>
            <br /> Após a desativação das capelas mortuárias do Hospital Regina,
            Alberto Franceschetti inicia a busca por um terreno para instalar as
            capelas da Krause, inauguradas no mesmo ano.
          </p>
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            2000
          </h3>
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={EightLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-end">
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            2003
          </h3>
          <p
            className="third-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>O PAK conquista a confiança da comunidade</b> <br />A empresa
            atinge a marca de 500 planos comercializados, consolidando o nome
            Krause como referência neste novo serviço.
          </p>
        </div>
        <div className="time-line-card-end">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Inauguração da MedCerta</b>
            <br /> A partir de iniciativas de Cristiano Franceschetti, é
            inaugurada a própria farmácia do Grupo Krause, a MedCerta, no centro
            de Novo Hamburgo.
          </p>
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            2004
          </h3>
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={SecondEightLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-start">
          <img
            src={NineLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            2006
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Conquista do primeiro prêmio</b> <br />A Funerária Krause ganha o
            prêmio Marcas que Marcam, realizado pelo Jornal NH, como a marca
            mais lembrada na região na categoria Funerária.
          </p>
        </div>
        <div className="time-line-card-start">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Retorno de Gilberto Franceschetti</b>
            <br /> Após um período ausente, Gilberto Franceschetti retorna para
            o Grupo Krause, dessa vez de maneira definitiva. Ele participa da
            mudança do PAK, que passa a se chamar Assiste Bem.
          </p>
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            2008
          </h3>
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
        </div>
        <div className="time-line-card-start">
          <img
            src={TenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={FourthMidArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: thirdMidColor, fontSize: props.subTitleSize }}>
            2010
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Perda de Cristiano Franceschetti</b>
            <br /> Cristiano Franceschetti falece prematuramente. Com a morte do
            irmão, Gilberto Franceschetti assume a liderança da empresa.
          </p>
        </div>
        <div className="time-line-card-mid">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Novo local de atendimento</b>
            <br /> A Funerária passa a atender junto das capelas, concentrando
            assim todo atendimento e acolhimento às famílias num único local.
          </p>
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2011
          </h3>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={ElevenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-end">
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2013
          </h3>
          <p
            className="third-card-text"
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Serviço de cremação</b>
            <br />A funerária Krause passa a oferecer a opção do serviço de
            cremação, utilizando parceiros especializados neste serviço.
          </p>
        </div>
        <div className="time-line-card-end">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Criação da Krause Assistencial</b>
            <br /> A nova empresa é criada para atender legislação referente aos
            planos funerários. Junto à Assite Bem, é oferecida uma rede de
            vantagens de mais de 400 parceiros e são atendidas 40 mil vidas.
          </p>
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2016
          </h3>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={TwelveLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-mid">
          <img
            src={ThirTeenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2017
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Lançamento do Pequenos Cometas</b>
            <br /> Grupo Krause lança lindo projeto social Pequenos Cometas, que
            oferece gratuitamente os serviços funerários para crianças menores
            de 10 anos.
          </p>
        </div>
        <div className="time-line-card-mid">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Inauguração do Memorial Krause</b>
            <br /> Grupo Krause inaugura o primeiro cemitério vertical
            biosseguro do sul do país, com tecnologia utilizada nos mais
            modernos cemitérios.
          </p>
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2020
          </h3>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={FourthTeenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-start">
          <img
            src={FifthTeenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2020
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Novas conquistas importantes</b>
            <br />O Grupo Krause recebe dois importantes prêmios que mostram a
            grandeza da marca:
            <br /> - 1º lugar como marca mais lembrada no Marcas & Valores, do
            Jornal NH;
            <br /> - 5ª posição entre as marcas mais lembradas e preferidas no
            Marcas de Quem Decide, do Jornal do Comércio.
          </p>
        </div>
        <div className="time-line-card-mid">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Ampliação do Memorial Krause</b> <br />
            Os espaços de sepultamento e ossário passam por reformas, aumentando
            a capacidade de atendimento às comunidades.
          </p>
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2021
          </h3>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={SixTeenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-end">
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2021
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Mais prêmios importantes</b> <br />
            Outras duas conquistas se somam às demais: <br />- 3º lugar entre as
            marcas mais lembradas do segmento funerária, no Marcas de Quem
            Decide, premiação do Jornal do Comércio; <br />- 4º lugar como a
            preferida dos gaúchos, na mesma categoria, no mesmo prêmio.
          </p>
        </div>
        <div className="time-line-card-mid">
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>Criação do Mais que Pet</b>
            <br />
            Grupo Krause cria o Mais que Pet, novo serviço voltado para os pets,
            com plano assistencial, rede de vantagens e serviços de cremação.
          </p>
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2022
          </h3>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={SevenTeenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
        </div>
        <div className="time-line-card-start">
          <img
            src={EighTeenLineImg}
            alt="linha do tempo"
            className="time-line-img"
          />
          <div className="time-line-span-container">
            <div className="time-line-span" />
          </div>
          <img
            src={LastArrow}
            alt="linha do tempo"
            className="time-line-arrow"
          />
          <h3 style={{ color: lastColor, fontSize: props.subTitleSize }}>
            2022
          </h3>
          <p
            style={{ color: props.textColor, fontSize: props.minimalTextSize }}
          >
            <b>100 anos de história</b>
            <br />
            Em 30 de março de 2022 o Grupo Krause comemora seus 100 anos, com 4
            unidades de negócios, 80 colaboradores, mais de 400 parceiros da
            Krause Assistencial e milhares de famílias acolhidas.
          </p>
        </div>
      </Carousel>
    </Container>
  );
}
